import type { FC } from "react";
import PollDisplay from "../../../../components/posts/post-types/poll/poll-display/poll-display";
import { usePolls } from "../../../../hooks/use-polls";
import { useViewerAuth } from "../../../../hooks/use-viewer-auth";

import * as CSS from "./viewer-polls.styles";

type ViewerPollsProps = {
	broadcastId: string | null;
};

const ViewerPolls: FC<ViewerPollsProps> = ({ broadcastId }) => {
	const polls = usePolls(broadcastId);
	const uid = useViewerAuth();

	if (!broadcastId || !uid) {
		return null;
	}

	return (
		<CSS.ViewerPollsContainer>
			{polls.map((poll) => (
				<CSS.PollCard key={poll.id}>
					<PollDisplay
						broadcastId={broadcastId}
						poll={poll}
						uid={uid}
						includePadding={false}
					/>
				</CSS.PollCard>
			))}
		</CSS.ViewerPollsContainer>
	);
};

export default ViewerPolls;
